<div class="whole-width-wrapper">
  <nav class="content-side-nav">
    <ul class="nav-content">
      @for (item of steps; track $index) {
        @if (item !== 'InitializationDone') {
          <button
            [ngClass]="{
              'nav-item': true,
              available:
                (steps.indexOf(item) <= steps.indexOf(lastAvailableStep) &&
                  !isLoading &&
                  (clientStatus === 'Draft' || clientStatus === 'New')) ||
                (!(clientStatus === 'Draft' || clientStatus === 'New') && item === 'FinalStep'),
              active: item === currentlySelected && !isLoading
            }"
            [disabled]="!(steps.indexOf(item) <= steps.indexOf(lastAvailableStep)) || isLoading || clientStatus === 'Submitted'"
            (click)="handleClick(item)">
            <div class="step-icons">
              @if ((steps.indexOf(item) <= steps.indexOf(lastAvailableStep) || isSubmitted) && !isLoading) {
                <div class="active-step-icon"></div>
              } @else {
                <img [attr.alt]="'imgAlt.serviceStepIcon' | translate" src="assets/images/service-step-icon.svg" />
              }
              @if ($index < steps.length - 1) {
                <div class="step-line">
                  <div class="step-line-inner"></div>
                </div>
              }
            </div>
            {{ 'components.serviceSteps.' + serviceName + '.' + item | translate }}
          </button>
        }
      }
    </ul>
  </nav>
</div>
<app-confirm-modal
  [isOpen]="isOpenConfirmBack"
  (confirm)="handleClick(pendingStep, true)"
  (cancel)="isOpenConfirmBack = false"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
